import { type AbstractControl, type ValidatorFn, type ValidationErrors } from '@angular/forms';

export function postalCodeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value) {
      if (!/^\d{5}$/.test(value)) {
        return { invalidZipCode: true };
      }
    }
    return null;
  };
}
